/* eslint-disable react/prop-types */
import React from 'react';
import { useDispatch } from 'react-redux';
import { removeModal } from 'Redux/modules/modal/actions';
import { Button, Modal } from 'semantic-ui-react';

const WarningModal = ({ data, id }) => {
  const dispatch = useDispatch();
  const onClose = () => {
    dispatch(removeModal(id));
    if (data.onClose) data.onClose();
  };
  const onConfirm = () => {
    if (data.onOk) data.onOk();
    dispatch(removeModal(id));
  };
  return (
    <div>
      <Modal
        onClose={onClose}
        open
        size={data?.size || 'small'}
        closeOnDimmerClick={data.closeOnDimmerClick ?? true}>
        <Modal.Content>{data.content}</Modal.Content>
        {!data.hideFooter && (
          <Modal.Actions>
            {data.onClose && (
              <Button
                onClick={() => {
                  onClose();
                }}>
                Cancel
              </Button>
            )}

            <Button
              id="limit-session-btn"
              primary
              onClick={() => {
                onConfirm();
              }}>
              {data.okText || 'OK'}
            </Button>
          </Modal.Actions>
        )}
      </Modal>
    </div>
  );
};

export default WarningModal;
